import styled from 'styled-components';

import {
   PRESCRIPTION_ISSUING_PANELS_GAP,
   PRESCRIPTION_ISSUING_RIGHT_PANEL_WIDTH,
} from './prescriptionIssuingPanel.constants';

const leftPanelWidth = `calc(100% - ${PRESCRIPTION_ISSUING_RIGHT_PANEL_WIDTH} - ${PRESCRIPTION_ISSUING_PANELS_GAP})`;

const StyledPrescriptionIssuingLeftPanel = styled.div`
   display: flex;
   flex-direction: column;
   min-width: ${leftPanelWidth};
   max-width: ${leftPanelWidth};
`;

StyledPrescriptionIssuingLeftPanel.displayName = 'StyledPrescriptionIssuingLeftPanel';

export { StyledPrescriptionIssuingLeftPanel };
